import React from "react";
import { useState, useRef } from "react";
import { useMediaQuery } from "react-responsive";
import Slider from "react-slick";

const PartnerShowCase = ({ content }) => {
  const { subtitle, title, partneritems } = content;
  const [tileDetail, setTileDetail] = useState(partneritems[0]);
  const [currentClientWidth, setCurrentClientWidth] = useState(0);
  const tileContainer = useRef({});
  const [arrowOffsetLeft, setArrowOffsetLeft] = useState(142.5);
  const isMobile = useMediaQuery({ query: "(max-width: 576px)" });

  const changeSlide = index => {
    if (isMobile) {
      setTileDetail(partneritems[index]);
    } else {
      changeTileDetail(tileDetail.logoImage, currentClientWidth);
    }
  };

  const settings = {
    infinite: false,
    speed: 500,
    fade: false,
    autoplay: false,
    dots: false,
    draggable: true,
    slidesToShow: isMobile ? 1 : 5,
    slidesToScroll: isMobile ? 1 : 5,
    arrows: true,
    cssEase: "cubic-bezier(0.165, 0.840, 0.440, 1.000)",
    variableWidth: undefined,
    afterChange: index => changeSlide(index)
  };

  const changeTileDetail = (logoImage, clientWidth) => {
    const logoElements = document.getElementsByClassName("slick-slide slick-active");
    let currentSlideIndex = 0;
    for (let index = 0; index < logoElements.length; index++) {
      const elementId = logoElements[index].getElementsByClassName("logo")[0].id;
      if (elementId === logoImage.id) {
        currentSlideIndex = index + 1;
        break;
      }
    }

    const details = partneritems.filter(item => {
      return item.logoImage.id === logoImage.id;
    });

    if (details.length > 0) {
      const padding = (tileContainer.current.clientWidth - clientWidth * 5) / 2 - 20;
      if (currentSlideIndex === 0) {
        setArrowOffsetLeft(-1000);
      } else {
        setArrowOffsetLeft(currentSlideIndex * clientWidth + padding - clientWidth / 2);
      }
      setTileDetail(details[0]);
      setCurrentClientWidth(clientWidth);
    }
  };

  return (
    <div id="PartnerShowCase">
      <div className="wrap">
        <div className="subtitle">{subtitle}</div>
        <div className="title">{title}</div>
        <div className="logoSlide">
          <Slider {...settings}>
            {partneritems.map(({ logoImage }, index) => (
              <div
                key={index}
                className="logo"
                id={logoImage.id}
                onClick={e => changeTileDetail(logoImage, e.currentTarget.clientWidth)}>
                <img src={logoImage.url} alt="slide" />
              </div>
            ))}
          </Slider>
        </div>
        {isMobile ? (
          <>
            <div className="tileTitle">{tileDetail.tileTitle}</div>
            <div className="tileSubtitle">{tileDetail.tileSubtitle}</div>
            <div className="tileContainer" ref={tileContainer}>
              <div className="content">
                <div className="tileImage">
                  <img src={tileDetail.tileImage.url} alt="tileImage" />
                </div>
                <div className="tileDesc">{tileDetail.tileDesc}</div>
                <div className="author">{tileDetail.author}</div>
                <div className="authorDesc">{tileDetail.authorDesc}</div>
              </div>
            </div>
          </>
        ) : (
          <div className="tileContainer" ref={tileContainer}>
            <div className="arrow-up" style={{ "--arrow-left-position": `${arrowOffsetLeft}px` }} />
            <div className="tileImage">
              <img src={tileDetail.tileImage.url} alt="tileImage" />
            </div>
            <div className="content">
              <div className="logoImage">
                <img src={tileDetail.logoImage.url} alt="logoImage" />
              </div>
              <div className="tileSubtitle">{tileDetail.tileSubtitle}</div>
              <div className="tileTitle">{tileDetail.tileTitle}</div>
              <div className="tileDesc">{tileDetail.tileDesc}</div>
              <div className="author">{tileDetail.author}</div>
              <div className="authorDesc">{tileDetail.authorDesc}</div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PartnerShowCase;
